import { SET_PDS } from './types';

const pds = (state = null, action) => {
  switch (action.type) {
    case SET_PDS:
      return action.pds;
    default:
      return state;
  }
};

export default pds;
